import { render, staticRenderFns } from "./CasePayments.vue?vue&type=template&id=257d0c7b&"
import script from "./CasePayments.vue?vue&type=script&lang=js&"
export * from "./CasePayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports